/* import __COLOCATED_TEMPLATE__ from './fdic-disclosure.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();